import React, { Component } from "react";

class LiveClassCard extends Component {
  render() {
    return (
      <div className="border rounded shadow-sm p-3">
        <div className="d-flex justify-content-between">
          <div>
            <div className="th-12 th-black">Meeting name</div>
            <div className="th-12 th-grey">Subject</div>
            <div className="th-12 th-grey">Teacher's Name</div>
          </div>
          <div>
            <button className="btn th-btn-primary-outline ">Join</button>
          </div>
        </div>
      </div>
    );
  }
}
export default LiveClassCard;
